import { Box, InputBase, useTheme } from "@mui/material"
import { useEffect, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import { showToastMessageUpdateRequest, showToastMessageRequestError } from "../../../utils/toasts";
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import ShValidatedNumberInput from "../../theme/inputs/ShValidatedNumberInput";
import { yupNumberRequired } from "../../../utils/validation";
import { useUpdateStockQuantityMutation } from "../../../newapi/warehouse/stockSlice";
import { useUpdateLineAmountFromProcessingMutation } from "../../../newapi/inbound/inboundsSlice";

const MInboundEditAmountReceived = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [updateLineFromProcessing,{isLoading}] = useUpdateLineAmountFromProcessingMutation();

    const [stockObject, setStockObject] = useState({
        remark: "",
        amountReceived:0,
    });

    const handleClose = (reloadData = false) => {
        setStockObject({
            remark: "",
            amountReceived:0,
        });

        props.handleClose(reloadData);
    }

    useEffect(() => {
        if (props.amounts) {
            setStockObject({
                remark:"",
                amountReceived:props.amounts.received,
            });
        }
    }, [props.amounts]);

    const [fieldErrors, setFieldErrors] = useState({});

    const rules = {
        amountReceived: yupNumberRequired('amountReceived', t, false),
    };
    
    const schema = yup.object().shape(rules);

    const updateLine = async () => {
        try {
            if (isLoading) return;
            if(stockObject.amountReceived < (props.amounts?.received - (props.amounts?.received - props.amounts?.moved))){
                console.log("smol");
                return;
            } 
            if(stockObject.amountReceived > props.amounts?.received){
                console.log("too beg");
                return;
            } 

            // Trim object for update
            const updateObject = {
                id: props.inboundId,
                lineId: props.inboundLineId,
                amountReceived: stockObject.amountReceived,
                remark: stockObject.remark,
            }

            setFieldErrors({});
            await schema.validate(updateObject, { abortEarly: false });
            const data = await updateLineFromProcessing(updateObject).unwrap();
            showToastMessageUpdateRequest(t, data);

            handleClose(true);
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                  ...acc,
                  [currentError.path]: currentError.message
                }), {});
          
                // Set the validation errors in the state
                setFieldErrors(errors);
              } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("update_failed"), t, err);
              }
        }
    };
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    // const handleChange = (key, value) => {
    //     setStockObject({
    //       ...stockObject,
    //       [key]: value
    //     });
    //     setFieldErrors({
    //         ...fieldErrors,
    //         [key]: ''
    //       });
    //   };
      
    return(
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    alignItems:'center',
                    gap:1
                }}>
                <Subheading>{t("edit_inbound_line_title")}</Subheading>
            </Box>
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2,
                    pb:1,
                }}
            >
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text>{t("current_quantity")}</Text>
                    </Box>
                    
                    
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            alignItems:'center',
                            height:32,
                            justifyContent:"space-between",
                            pl:2,
                            pr:0.5,
                        }}
                    >
                        <Text light fontSize={16}>{props.amounts?.received}</Text>
                        <Box
                            sx={{
                                background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],       
                                boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                border:`1px solid ${colors.grey[100]}`,
                                px:1,
                                gap:2,
                                display:'flex',
                                height:24,
                                borderRadius:3,
                            }}
                        >
                            <Text light>{t("minimum")}</Text>
                            <Text>{props.amounts?.received - (props.amounts?.received - props.amounts?.moved)}</Text>
                        </Box>
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text>{t("new_quantity")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            alignItems:'center',
                            height:32,
                            justifyContent:"space-between",
                            pl:2,
                        }}
                    >
                        <InputBase
                            autoFocus
                            type="tel"
                            onChange={(e) => {
                                const input = e.target.value;
                                if (/^\d*$/.test(input)) {
                                    if (input === '' || /^[0-9]\d*$/.test(input)) {
                                        setStockObject(stockObject => ({
                                            ...stockObject,
                                            amountReceived: input,
                                        }))
                                    }
                                }
                            }}
                            value={stockObject.amountReceived}
                            sx={{
                                colors:colors.txt["primary"],
                            }}
                        />
                    </Box>
                </Box>
                 <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"flex-start",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text>{t("remark")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            alignItems:'center',
                            justifyContent:"space-between",
                            pl:2,
                        }}
                    >
                        <InputBase
                            multiline 
                            rows={3} 
                            onChange={(e) => {
                                const input = e.target.value;
                                setStockObject(stockObject => ({
                                    ...stockObject,
                                    remark: input,
                                }))
                            }}
                            value={stockObject.remark}
                            sx={{
                                flex:1,
                                colors:colors.txt["primary"],
                            }}
                        />
                    </Box>
                </Box>
               
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton tabIndex={-1} isCancel={true} className={"always-visible"} onClick={handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton isLoading={isLoading} className={"group-btn"} color={"green"}
                    variant="contained" 
                    onClick={() => updateLine()}
                    >{t("save")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MInboundEditAmountReceived;
